import { Box, Text, TextProps } from '@chakra-ui/react';
import { escapeRegex } from '@common/util/strings';
import { isNotNullish } from '@common/util/types';

const HighlightedText = (
    props: TextProps & {
        text: string;
        query: string | null;
    }
) => {
    const { text, query, ...rest } = props;
    return <Text {...rest}>{highlightMatches(text, query)}</Text>;
};

export default HighlightedText;

const highlightMatches = (text: string, query: string | null) => {
    if (!query) {
        return text;
    }

    return text
        .split(new RegExp(`(${escapeRegex(query)})`, 'gi'))
        .map((part, i) => {
            if (part === '') return null;

            const isMatch = part.toLowerCase() === query.toLowerCase();

            return (
                <Box
                    key={i}
                    as="span"
                    {...(isMatch && { bg: 'yellow.200', fontWeight: 'bold' })}
                >
                    {part}
                </Box>
            );
        })
        .filter(isNotNullish);
};
